import styled from 'styled-components';

import theme from '../../utils/theme';

const { colors } = theme;

export const ErrorMessageP = styled.p`
	font-size: 0.75rem;
	color: ${colors.danger};
	margin-top: 5px;
`;
